/**
 * 인증 리다이렉트 쿼리 파라미터.
 *
 * middleware(Edge runtime), axios 인터셉터, sign_in 페이지가 모두 공유한다.
 * `authReturnPath.ts` 가 `@/middleware` 를 import하므로, middleware가 그쪽에서
 * 상수를 가져오면 순환 참조가 된다. 그래서 의존성 없는 이 파일에 따로 둔다.
 */

/** 세션 만료 안내 토스트를 sign_in 페이지에서 띄우기 위한 파라미터. */
export const SESSION_EXPIRED_PARAM = 'fallback'
export const SESSION_EXPIRED_VALUE = 'session_expired'

/** 재로그인 후 돌아갈 경로. 소비는 로그인 성공 시점 한 곳에서만 한다. */
export const RETURN_PATH_PARAM = 'from'
